<template>

    <Path>
        <template v-slot:path>
            <li>
                <router-link :to="{ name: 'dashboard' }">الصفحة الرئيسية</router-link>
            </li>
            <li> <span class="divider"> / </span><a href="#services" @click="$router.push({ name: 'dashboard' })">الخدمات
                </a> </li>
            <li> <span class="divider"> / </span>
                <router-link :to="{ name: 'translatedservices' }">الخدمات المترجمة</router-link>
            </li>
            <li> <span class="divider"> / </span><a href="#">{{ docPath }}</a> </li>
        </template>
    </Path>

    <section id="content">
        <div class="py-4 grayBG">
            <div class="container">
                <div class="row">
                    <div class="col-12 mb-2">
                        <h2 class="blueFont ">{{ docName }}</h2>
                    </div>
                    <div class="col-md-3">
                        <p class="text-danger fw-bold"> <i class="bi bi-clock fw-bold"></i> مدة إتمام الخدمة</p>
                        <p>7 أيام عمل</p>
                    </div>
                    <div class="col-md-3">

                        <p class="text-danger fw-bold"> <i class="fw-bold">ج.م</i> رسوم الخدمة</p>
                        <p>{{ servicePrice }} جنيهاً مصرياً</p>
                    </div>
                    <div class="col-md-6">
                        <div class="d-flex justify-content-md-end justify-content-center">
                            <button type="button" @click="ToDoc" :disabled="!accepted" class="btn btn-primary">بدء
                                الخدمة <i class="bi bi-arrow-left-circle float-start "></i></button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </section>

    <section>
        <div class="py-5 ">
            <div class="container">
                <div class="row">
                    <div class="col-12 my-2">
                        <h3>عن الخدمة</h3>
                        <p>تتيح هذه الخدمة استخراج {{ docName }} لمقدم الطلب او لشخص اخر فى حدود الشروط والقوانين</p>
                    </div>
                    <div class="col-12 my-2">
                        <h3> شروط الخدمة</h3>
                        <ul class="numbers_list">
                            <li>أن يكون سبق لك إصدار الوثيقة المترجمه من أحد مقرات قطاع الأحوال المدنية لخدمات الوثائق
                                المترجمه</li>
                        </ul>
                    </div>
                    <div class="col-12 my-2">
                        <h3>المستندات المطلوبة</h3>
                        <p>لا يوجد مستندات مطلوبة</p>
                        <div class="form-check my_Form">
                            <label class="form-check-label blueFont fw-bold" for="flexCheckDefault">
                                موافق/ة على الشروط و الأحكام وسبق لك إصدار الوثيقة من أحد مقرات الأحوال المدنية
                            </label>
                            <input v-model="accepted" class="form-check-input" type="checkbox" value=""
                                id="flexCheckDefault">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import sharedMethods from "@/shared/sharedMethods";
import Path from "@/components/Path.vue";
import { debugLog } from "@/plugins/debug";

export default {
    ... sharedMethods,
    name: 'TranslatedRegulationsView',
    components: { Path },
    data() {
        return {
            accepted: false,
            document_lookups: [],
            Doc_Code: '',
            servicePrice: ''
        }
    },
    created() {
        setTimeout(() => {
            sharedMethods.get_servicePrice("translatedDocPrice").then(res => { this.servicePrice = res; });
        }, 200)
    },
    watch: {
        accepted(newValue) {
            if (newValue) {
                window.scrollTo({ top: 0, behavior: "smooth" });
            }
        },
    },
    computed: {
        docName() {
            return this.$route.params.docType === 'birth' ? "شهادة ميلاد مترجمه" :
                this.$route.params.docType === 'death' ? "قيد وفاة مترجم" :
                    this.$route.params.docType === 'marriage' ? "وثيقة زواج مترجمه" :
                        this.$route.params.docType === 'divorce' ? "وثيقة طلاق مترجمه" :
                            this.$route.params.docType === 'personalrecord' ? "قيد فردى مترجم" :
                                this.$route.params.docType === 'familyrecord' ? "قيد عائلى مترجم" : ""
        },
        docPath() {
            return this.$route.params.docType === 'birth' ? "استخراج شهادة ميلاد مترجمه" :
                this.$route.params.docType === 'death' ? "استخراج قيد وفاه مترجمه" :
                    this.$route.params.docType === 'marriage' ? "استخراج قسيمة زواج مترجمه" :
                        this.$route.params.docType === 'divorce' ? " استخراج قسيمة طلاق مترجمه" :
                            this.$route.params.docType === 'personalrecord' ? "استخراج قيد فردى مترجم" :
                                this.$route.params.docType === 'familyrecord' ? " استخراج قيد عائلى مترجم" : ""
        },

    },
    methods: {
        ToDoc() {
            debugLog(this.$route.params.docType);
            if (this.$route.params.docType === 'birth') { this.$router.push({ name: 'translatedbirthRequest' }); this.docPath = "استخراج شهادة ميلاد مترجمه"; }
            if (this.$route.params.docType === 'death') { this.$router.push({ name: 'translateddeathRequest' }); this.docPath = "استخراج قيد وفاه مترجمه"; }
            if (this.$route.params.docType === 'marriage') { this.$router.push({ name: 'translatedmarriageRequest' }); this.docPath = "استخراج قسيمة زواج مترجمه"; }
            if (this.$route.params.docType === 'divorce') { this.$router.push({ name: 'translateddivorceRequest' }); this.docPath = "استخراج قسيمة طلاق مترجمه"; }
            if (this.$route.params.docType === 'personalrecord') { this.$router.push({ name: 'translatedpersonalrecord' }); this.docPath = "استخراج قيد فردى مترجم"; }
            if (this.$route.params.docType === 'familyrecord') { this.$router.push({ name: 'translatedfamilyrecord' }); this.docPath = "استخراج قيد عائلى مترجم"; }
        },
    }
}
</script>